export const WEEKDAYS: { name: string, value: number}[] = [
  {
    name: $localize`:@@monday:Montag`,
    value: 1,
  },
  {
    name: $localize`:@@tuesday:Dienstag`,
    value: 2,
  },
  {
    name: $localize`:@@wednesday:Mittwoch`,
    value: 3,
  },
  {
    name: $localize`:@@thursday:Donnerstag`,
    value: 4,
  },
  {
    name: $localize`:@@friday:Freitag`,
    value: 5,
  },
  {
    name: $localize`:@@saturday:Samstag`,
    value: 6,
  },
  {
    name: $localize`:@@sunday:Sonntag`,
    value: 0,
  },
];

export const GENDERS: { gender: string, name: string }[] = [
  {
    gender: ' - ',
    name: ' - ',
  },
  {
    gender: 'weiblich',
    name: $localize`:@@gender-female:weiblich`,
  },
  {
    gender: 'männlich',
    name: $localize`:@@gender-male:männlich`,
  },
  {
    gender: 'divers',
    name: $localize`:@@gender-diverse:divers`,
  },
];

export const STATUS_GROUPS: { group: string, name: string }[] = [
  {
    group: 'Wissenschaftliche/r Mitarbeiter/in',
    name: $localize`:@@status-group-scientific-assistant:Wissenschaftliche/r Mitarbeiter/in`,
  },
  {
    group: 'Professor/in',
    name: $localize`:@@status-group-professor:Professor/in`,
  },
  {
    group: 'Doktorand/in',
    name: $localize`:@@status-group-phd-student:Doktorand/in`,
  },
  {
    group: 'Promovierte',
    name: $localize`:@@status-group-doctorate:Promovierte`,
  },
  {
    group: 'Student/in',
    name: $localize`:@@status-group-student:Student/in`,
  },
  {
    group: 'Sonstige/r Mitarbeiter/in',
    name: $localize`:@@status-group-other-employee:Sonstige/r Mitarbeiter/in`,
  },
  {
    group: 'art-employee',
    name: $localize`:@@status-group-art-employee:Künstlerisch-gestalterische/r Forscher/in`,
  },
  {
    group: 'special-task-teacher',
    name: $localize`:@@status-group-special-task-teacher:Lehrkraft für besondere Aufgaben`,
  },
];
